<template>
  <div class="room-type-manage-edit-modal">
    <el-form
      class="detail-form"
      label-position="top"
      :model="formData"
      :rules="rules"
      ref="formRef"
    >
      <el-form-item label="房型名称：" prop="roomTypeName">
        <el-input
          v-model="formData.roomTypeName"
          placeholder="请输入"
        ></el-input>
      </el-form-item>
      <el-form-item label="宜住人数：" prop="maxLiveNum">
        <el-input
          type="number"
          min="1"
          class="w-200 m-r-10"
          v-model="formData.maxLiveNum"
          placeholder="请输入"
        ></el-input
        >人
      </el-form-item>
      <el-form-item label="户型信息：" prop="bedroomNum">
        <el-row class="w-p-100 m-b-10">
          <el-col :span="6">
            <span>卧室</span>
            <el-input-number
              v-model="formData.bedroomNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="1"
              :max="10"
            ></el-input-number>
          </el-col>
          <el-col :span="6">
            <span>客厅</span>
            <el-input-number
              v-model="formData.liveroomNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="0"
              :max="10"
            ></el-input-number>
          </el-col>
          <el-col :span="6">
            <span>卫生间</span>
            <el-input-number
              v-model="formData.washroomNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="0"
              :max="10"
            ></el-input-number>
          </el-col>
          <el-col :span="6">
            <span>厨房</span>
            <el-input-number
              v-model="formData.kitchenNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="0"
              :max="10"
            ></el-input-number>
          </el-col>
        </el-row>
        <el-row class="w-p-100 m-b-10">
          <el-col :span="6">
            <span>书房</span>
            <el-input-number
              v-model="formData.studyroomNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="0"
              :max="10"
            ></el-input-number>
          </el-col>
          <el-col :span="6">
            <span>阳台</span>
            <el-input-number
              v-model="formData.balconyNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="0"
              :max="10"
            ></el-input-number>
          </el-col>
          <el-col :span="6">
            <span>床位</span>
            <el-input-number
              v-model="formData.bedNum"
              controls-position="right"
              class="w-100 m-l-10"
              :min="1"
              :max="10"
            ></el-input-number>
          </el-col>
        </el-row>
      </el-form-item>
      <el-form-item label="价格：" prop="weekdayPrice">
        <el-row class="w-p-100 m-b-10">
          <el-col :span="8">
            <span>平日价格</span>
            <el-input-number class="w-100 m-l-10" v-model="formData.weekdayPrice" controls-position="right"></el-input-number>
            元
          </el-col>
          <el-col :span="8">
            <span>钟点房价格</span>
            <el-input-number class="w-100 m-l-10" v-model="formData.hourPrice" controls-position="right"></el-input-number>
            元
          </el-col>
        </el-row>
        <el-row class="w-p-100">
          <el-col :span="24">
            <span>周末价格</span>
            <el-input-number class="w-100 m-l-10" v-model="formData.weekendPrice" controls-position="right"></el-input-number>
            元
          </el-col>
        </el-row>
      </el-form-item>
      
      <div style="text-align: center; padding: 20px; width: 100%">
        <el-button class="submit-btn" @click="handleSave">保存</el-button>
        <el-button class="cancel-btn" @click="handleCancel">取消</el-button>
      </div>
    </el-form>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: {
    roomTypeId: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      formData: {},
      rules: {
        roomTypeName: [{ required: true, message: '请填写房型名称', trigger: 'blur' }],
        maxLiveNum: [{ required: true, message: '请填写宜住人数', trigger: 'blur' }],
        bedroomNum: [{ required: true, message: '请补充卧室和床位信息', trigger: 'change' }],
        // weekdayPrice: [{
        //   validator: (rule, value, callback) => {
        //     if (!this.formData.weekdayPrice) {
        //       callback(new Error('请设置平日价格'))
        //     } else if (!this.formData.hourPrice) {
        //       callback(new Error('请设置钟点房价格'))
        //     } else if (!this.formData.weekendPrice) {
        //       callback(new Error('请设置周末价格'))
        //     } else {
        //       callback()
        //     }
        //   }, trigger: 'blur'
        // }]
      }
    }
  },
  created() {
    if (this.roomTypeId) {
      this.getDetail();
    } else {
      this.initFormData();
    }
  },
  watch: {
  },
  methods: {
    ...mapActions(["fetchData"]),

    // 编辑：获取详情
    getDetail() {
      this.fetchData({
        url: 'ROOM.TYPE.GET_DETAIL',
        params: { id: this.roomTypeId }
      }).then(res => {
        res && (this.formData = res);
      })
    },

    // 新增：初始化formData
    initFormData() {
      this.formData = {
        roomTypeName: '',
        maxLiveNum: 1,
        bedNum: 1,
        balconyNum: 0,
        studyroomNum: 0,
        washroomNum: 0,
        kitchenNum: 0,
        liveroomNum: 0,
        bedroomNum: 0,
        weekdayPrice: 0,
        hourPrice: 0,
        weekendPrice: 0
      }
    },

    // 保存
    handleSave() {
      this.$refs['formRef'].validate((valid) => {
        if (valid) {
          const currShopStr = localStorage.getItem('curShop'),
            currShop = currShopStr && JSON.parse(currShopStr);
          if (!currShop || !currShop.id) return;
          if (!this.formData.storeId) {
            this.formData.storeId = currShop.id;
          }
          this.formData.weekdayPrice || (this.formData.weekdayPrice = 0);
          this.formData.hourPrice || (this.formData.hourPrice = 0);
          this.formData.weekendPrice || (this.formData.weekendPrice = 0);
          this.fetchData({
            url: 'ROOM.TYPE.POST_SAVE',
            method: 'post',
            headers: { "Content-Type": "application/json" },
            params: this.formData
          }).then(res => {
            if (res) {
              this.$message.success('操作成功！')
              this.handleCancel(true)
            } else {
              this.$message.error('操作失败！')
            }
          }).catch(() => {
            this.$message.error('操作失败！')
          })
        }
      })
    },

    // 关闭对话框
    handleCancel(success) {
      this.$emit('close', success)
    }
  }
}
</script>

<style lang="less">
.room-type-manage-edit-modal {
  color: #000;
  .el-form.detail-form {
    width: 95% !important;
  }
}
</style>